export const CDocumentOriginUnknown = 'value:unknown'
